'use strict';

module.exports = require('../../date-picker/locale/zh_CN');


/*****************
 ** WEBPACK FOOTER
 ** ./components/basic/calendar/locale/zh_CN.js
 ** module id = 597
 ** module chunks = 0
 **/